import createRequest from '../core/request'
const PREFIX = __DEV__ ? '/localApi' : '' // 本地开发，使用代理, 去除本地PHP开发依赖
/**
 * 登录
 */
export function login(data) {
  return createRequest('UAPI').post(`${PREFIX}/user/loginnew`, data, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    withCredentials: true
  })
}

/**
 * 新版gt登录
 */
export function loginGt(data) {
  return createRequest('UAPI').post(`${PREFIX}/user/logingt`, data, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    withCredentials: true
  })
}

/**
 * 重置IP 发送邮件
 */
export function resetIp(data) {
  const { account, account_type, type } = data
  return createRequest('CORPAPI').post(
    `/send_emailsms_with_verify_v2`,
    {
      callback: data.callback
    },
    {
      params: {
        account,
        account_type,
        type
      }
    }
  )
}

/**
 * 关闭IP限制
 */
export function close_ip_limit(params) {
  return createRequest('CORPAPI').get('/close_ip_limit', {
    params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

/**
 * 登出
 */
export function logout() {
  return createRequest('UAPI').get(`${PREFIX}/user/logoutNew`)
}

/**
 * 检测token是否有效
 */
export function token_check(params) {
  return createRequest('CORPAPI').get('/token_check', {
    params
  })
}

/**
 * 获取分享邀请链接
 */
export function get_invite_link(params) {
  return createRequest('CORPAPI').get('/get_invite_link', {
    params
  })
}

/**
 * 查询剩余购买数
 */
export function query_purchase_product(params) {
  return createRequest('CORPAPI').get('/query_purchase_product_v2', {
    params
  })
}

/**
 * 获取个人电子名片链接
 */
export function share_myclient(params) {
  return createRequest('ShareAPI').get('/share_myclient_v2', {
    params
  })
}

/**
 * 自动同步数据 迁移PHP同步接口
 * 调用逻辑
 * 场景一【并集】1、不在手机端2、不在导出到CRM页面3、不在Excel批量导入名片页面4、不在支付相关页面5、不在/user/ 路径下页面6、查询消息数量!=0 调用
 * 场景二 1、公司标签管理 修改和删除标签时调用
 * https://web-api.intsig.net/project/613/interface/api/171839
 */
export function auto_sync(params = {}) {
  return createRequest('CORPAPI')
    .get('/user/message/autosync', { params })
    .catch(() => {
      // 捕获autosync异常
    })
}

/**
 * 登出
 * @link
 * @param token
 * @returns {*}
 */
// let logout = token => {
//   return createRequest('UAPI').get('/logout', {
//     params: {
//       token: token
//     }
//   })
// }

// get(url, options)
// post(url, body, options)
// options.params === get

// export default {
//   // login
//   logout
// }

/**
 * 发送验证码
 */
export function send_emailsms_with_verify(params, data) {
  return createRequest('CORPAPI2').post('/send_emailsms_with_verify_v2', data, {
    params
  })
}
/**
 * 验证首次登录
 */
export function check_first_login(params, data) {
  return createRequest('CORPAPI').post('/admin/check_first_login', data, {
    params
  })
}

/**
 * 获得用户当前名片上传限制信息
 * https://web-api.intsig.net/project/613/interface/api/157642
 */
export function get_upload_limit_info(params) {
  return createRequest('CORPAPI')
    .get('/user/vcf/upload_limit_info', {
      params
    })
    .catch(e => {
      console.log('upload_limit_info axios fail', e)
    })
}

/**
 * bcr识别结果上传
 * https://web-api.intsig.net/project/613/interface/api/158775
 */
export function commit_ocr_info(params, data) {
  return createRequest('SyncAPI')
    .post('/common/web_bcr_commit', data, {
      params
    })
    .catch(e => {
      console.log('web_bcr commit fail', e)
    })
}
/**
 * web端取消bcr识别数据
 * https://web-api.intsig.net/project/613/interface/api/170150
 */
export function cancel_ocr(params, data) {
  return createRequest('SyncAPI')
    .post('/common/web_bcr_cancel', data, {
      params
    })
    .catch(e => {
      console.log('web_bcr cancel fail', e)
    })
}

/**
 * 获取dps额度是否不足
 */
export function get_dps_limit(params = {}) {
  return createRequest('SyncAPI').get('/common/dps_quota_reminder', {
    params
  })
}
/**
 * 启信宝获取公司
 */
export function get_qxb_company(params = {}) {
  return createRequest('QXBAPI').get('/enterprise/getAutoComplete', {
    params
  })
}
